import { render } from "./view.vue?vue&type=template&id=a8fb1e14&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=a8fb1e14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a8fb1e14"

export default script